<template>
  <div class="section" :id="blockData.title">
      <div class="title" :style="{backgroundImage: `url(${titleImage})`,backgroundSize: 'auto 87px'}"></div>
      <div class="list">
          <template v-for="(item,index) in blockData.list" >
              <card :key="index" :type="blockData.title" :info="item"></card>
          </template>
      </div>
  </div>
</template>

<script>
  import Card from '../components/Card.vue'
  
  export default {
    components: {
      Card
    },
    props:{
      blockData:{
        default:{}
      }
    },
    computed:{
      titleImage(){
        return require(`../../../assets/images/pc/title/${this.blockData.title}.png`)
      }
    }
  }
</script>

<style lang="less" scoped>
  .section{
    width: 1080px;
    margin: 0 auto;
  }
  .title {
  height: 56px;
  background: url(../../../assets/images/pc/title/burst.png) no-repeat center center;
  background-size: auto 87px;
  margin: 35px auto 23px;
}
.list{
  width: 1120px;
  display: flex;
  flex-wrap: wrap;
}
</style>